export default __webpack_public_path__ + "static/media/logo.28510af3.svg";